"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @jsx jsx */

var core_1 = require("@emotion/core");

var styled_1 = __importDefault(require("../../../theme/styled"));

var emotion_theming_1 = require("emotion-theming");

var BreadcrumbWrapper = styled_1["default"].li({
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  display: 'inline-block',
  '&:hover': {
    opacity: 1
  }
}, function (_ref) {
  var breadcrumb = _ref.theme.breadcrumb;
  return {
    opacity: breadcrumb.crumbOpacity
  };
});
var BreadcrumbSeparator = styled_1["default"].span(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: '1em',
    margin: theme.breadcrumb.margin
  };
});
var BreadcrumbContent = styled_1["default"].ul(function (_ref3) {
  var theme = _ref3.theme,
      inverse = _ref3.inverse;
  return {
    color: inverse ? theme.breadcrumb.inverseColor : theme.breadcrumb.color,
    margin: 0,
    padding: 0
  };
});

var Breadcrumb = function Breadcrumb(_ref4) {
  var theme = _ref4.theme,
      className = _ref4.className,
      _ref4$inverse = _ref4.inverse,
      inverse = _ref4$inverse === void 0 ? false : _ref4$inverse,
      items = _ref4.items,
      _ref4$seperator = _ref4.seperator,
      seperator = _ref4$seperator === void 0 ? core_1.jsx(BreadcrumbSeparator, {
    theme: theme
  }, "/") : _ref4$seperator;

  var getCrumbs = function getCrumbs() {
    var crumbs = [];

    for (var index = 0; index < items.length; index++) {
      var element = items[index];

      if (index !== items.length - 1) {
        crumbs.push(core_1.jsx(BreadcrumbWrapper, {
          theme: theme
        }, element));
        crumbs.push(seperator);
      } else {
        crumbs.push(element);
      }
    }

    return crumbs;
  };

  return core_1.jsx("nav", {
    className: className,
    "aria-label": "breadcrumbs"
  }, core_1.jsx(BreadcrumbContent, {
    inverse: inverse
  }, getCrumbs()));
};

exports["default"] = emotion_theming_1.withTheme(Breadcrumb);